import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { normalizeSize } from '../../utils'; // import './loader.scss'

var Dots = function Dots(props) {
  var styles = {
    width: props.size ? normalizeSize(props.size) : normalizeSize(props.width),
    height: props.size ? normalizeSize(props.size) : normalizeSize(props.height),
    backgroundColor: props.color
  };
  var wrapperStyles = {
    height: props.size ? normalizeSize(props.size) : normalizeSize(props.height)
  };
  return React.createElement("div", {
    style: wrapperStyles,
    className: classNames('dots flex-inline', props.className)
  }, React.createElement("div", {
    className: "bounce1",
    style: styles
  }), React.createElement("div", {
    className: "bounce2",
    style: styles
  }), React.createElement("div", {
    className: "bounce3",
    style: styles
  }));
};

Dots.propTypes = {
  /**
   * Class to be appended to thw wrapping element
   */
  className: PropTypes.string,

  /**
   * Color of the dots
   */
  color: PropTypes.string,

  /**
   * Height of individual dots
   */
  height: PropTypes.number,

  /**
   * Width of individual dots
   */
  width: PropTypes.number,

  /**
   * Size of individual dots
   */
  size: PropTypes.number
};
Dots.defaultProps = {
  className: '',
  color: '#6e7278',
  height: 8,
  width: 8
};
Dots.displayName = 'Dots';
export default Dots;